module.exports = __webpack_public_path__ + "img/shark-icon-1.69baeb73.svg";